export default __webpack_public_path__ + "static/RTSS-ea295bdf029a11fe02024ca4e4c26144.png";